import React from 'react'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import Sidebar from '../../Components/Sidebar'
import UpdateServices from './UpdateServices'

const index = () => {
  return (
        <React.Fragment>
            <div className='wrapper'>
                <Header/>
                <Sidebar/>
                <UpdateServices/>
                <Footer/>
                
            </div>
        </React.Fragment>
    )
}

export default index